import Vue from 'vue'
import Router from 'vue-router'
import $store from '../store/index.js'

Vue.use(Router)
// meta:{title:''}, 
const routes = [{
    path: '/',
    name: 'home',
    component:resolve => require(['@/pages/home/home.vue'], resolve)
  },
    {//風險披露
      path: '/HKIDR',
      name: 'HKIDR',
      component:resolve => require(['@/pages/home/HKIDR.vue'], resolve)
    },
  {//風險披露
    path: '/sreachpage',
    name: 'sreachpage',
    component:resolve => require(['@/pages/sreachpage/sreachpage.vue'], resolve)
  },
  {//風險披露
    path: '/riskdisclaimer',
    name: 'riskdisclaimer',
    meta:{title:'Risk Disclosure Statement'}, 
    component:resolve => require(['@/pages/safenotice&advice/riskdisclaimer.vue'], resolve)
  },
  {//隱私條例
    path: '/privacypolicy',
    name: 'privacypolicy',
    meta:{title:'Privacy Data Policy'}, 
    component:resolve => require(['@/pages/safenotice&advice/privacypolicy.vue'], resolve)
  },
  {//个人声明
    path: '/personalStatement',
    name: 'personalStatement',
    meta:{title:'Personal Data Collection Statement'}, 
    component:resolve => require(['@/pages/safenotice&advice/personalStatement.vue'], resolve)
  },
  {
    path: '/products',
    name: 'products',
    component:resolve => require(['@/pages/products/products.vue'], resolve)
  },
  {
    path: '/boundfund',
    name: 'boundfund',
    component:resolve => require(['@/pages/bondfund/boundfund.vue'], resolve)
  },
  {
    path: '/hyperlinkpolicy',
    name: 'hyperlinkpolicy',
    meta:{title:'Hyperlink Policy'}, 
    component:resolve => require(['@/pages/safenotice&advice/hyperlinkpolicy.vue'], resolve)
  },
  {
    path: '/ro-type149',
    name: 'ro-type149',
    component:resolve => require(['@/pages/joinus/ro-type149.vue'], resolve)
  },
  {
    path: '/ro-type1',
    name: 'ro-type1',
    component:resolve => require(['@/pages/joinus/ro-type1.vue'], resolve)
  },
  {
    path: '/ro-type2',
    name: 'ro-type2',
    component:resolve => require(['@/pages/joinus/ro-type2.vue'], resolve)
  },
  {
    path: '/ro-type3',
    name: 'ro-type3',
    component:resolve => require(['@/pages/joinus/ro-type3.vue'], resolve)
  },
  {
    path: '/ro-type4',
    name: 'ro-type4',
    component:resolve => require(['@/pages/joinus/ro-type4.vue'], resolve)
  },
  {
    path: '/joinus',
    name: 'joinus',
    meta:{title:'Join Us'}, 
    component:resolve => require(['@/pages/joinus/joinus.vue'], resolve)
  },
  {
    path: '/safenotice&advice',
    name: 'safenotice&advice',
    meta:{title:'Security Usage Tips'}, 
    component:resolve => require(['@/pages/safenotice&advice/safenotice&advice.vue'], resolve)
  },
  {
    path: '/terms&conditions',
    name: 'terms&conditions',
    meta:{title:'Terms & Conditions of Use'}, 
    component:resolve => require(['@/pages/safenotice&advice/terms&conditions.vue'], resolve)
  },
  {
    path: '/global-stocks',
    name: 'hongkong',
    component:resolve => require(['@/pages/home/compoents/hongkong.vue'], resolve)
  },
  {
    path:'/hkstock-intro',
    name:'honggu',
    component:resolve => require(['@/pages/home/compoents/honggu.vue'],resolve)
  },
  {
    path:'/hkstock-method',
    name:'hongjiaoyi',
    component:resolve => require(['@/pages/home/compoents/hongjiaoyi.vue'],resolve)
  },
  {
    path:'/hkstock-fees',
    name:'hongfuwu',
    component:resolve => require(['@/pages/home/compoents/hongfuwu.vue'],resolve)
  },
  {
    path:'/usstock-intro',
    name:'usagu',
    component:resolve => require(['@/pages/usapage/usagu.vue'],resolve)
  },
  {
    path:'/usstock-method',
    name:'usajiaoyi',
    component:resolve => require(['@/pages/usapage/usajiaoyi.vue'],resolve)
  },
  {
    path:'/usstock-fees',
    name:'usafuwu',
    component:resolve => require(['@/pages/usapage/usafuwu.vue'],resolve)
  },
  {
    path:'/fund',
    name:'bondjiaoyi',
    component:resolve => require(['@/pages/bondfund/bondjiaoyi.vue'],resolve)
  },
  {
    path:'/bonds',
    name:'bondfund',
    component:resolve => require(['@/pages/bondfund/bondfund.vue'],resolve)
  },
  {
    path:'/ipo',
    name:'newshares',
    component:resolve => require(['@/pages/newshares/newshares.vue'],resolve)
  },
  {
    path:'/newcalendar',
    name:'newcalendar',
    component:resolve => require(['@/pages/newshares/newcalendar.vue'],resolve)
  },{
    path:'/stock-transfer',
    name:'zhuancang',
    component:resolve => require(['@/pages/zhuancang/zhuancang.vue'],resolve)
  },{
    path:'/sgstock-intro',
    name:'xinjiapo',
    component:resolve => require(['@/pages/xinjiapo/xinjiapo.vue'],resolve)
  },{
    path:'/sgstock-method',
    name:'xinjiapojiaoyi',
    component:resolve => require(['@/pages/xinjiapo/xinjiapojiaoyi.vue'],resolve)
  },{
    path:'/sgstock-fees',
    name:'xinjiapofuwu',
    component:resolve => require(['@/pages/xinjiapo/xinjiapofuwu.vue'],resolve)
  },{
    path:'/jpstock-intro',
    name:'japan',
    component:resolve => require(['@/pages/japan/japan.vue'],resolve)
  },{
    path:'/jpstock-fees',
    name:'japanfuwu',
    component:resolve => require(['@/pages/japan/japanfuwu.vue'],resolve)
  },{
    path:'/jpstock-method',
    name:'japanjiaoyi',
    component:resolve => require(['@/pages/japan/japanjiaoyi.vue'],resolve)
  },
  {
    path:'/destock-intro',
    name:'germany',
    component:resolve => require(['@/pages/germany/germany.vue'],resolve)
  },{
    path:'/destock-method',
    name:'germanyjiaoyi',
    component:resolve => require(['@/pages/germany/germanyjiaoyi.vue'],resolve)
  },{
    path:'/destock-fees',
    name:'germanyfuwu',
    component:resolve => require(['@/pages/germany/germanyfuwu.vue'],resolve)
  },
  {
    path:'/twstock-intro',
    name:'austockfuwu',
    component:resolve => require(['@/pages/twstock/twstock.vue'],resolve)
  },  {
    path:'/austock-intro',
    name:'austock',
    component:resolve => require(['@/pages/austock/austock.vue'],resolve)
  },{
    path:'/austock-method',
    name:'austockjiaoyi',
    component:resolve => require(['@/pages/austock/austockjiaoyi.vue'],resolve)
  },{
    path:'/austock-fees',
    name:'austockfuwu',
    component:resolve => require(['@/pages/austock/austockfuwu.vue'],resolve)
  },
  {
    path:'/twstock-intro',
    name:'austockfuwu',
    component:resolve => require(['@/pages/twstock/twstock.vue'],resolve)
  },{
    path:'/twstock-fees',
    name:'twstockfuwu',
    component:resolve => require(['@/pages/twstock/twstockfuwu.vue'],resolve)
  },{
    path:'/twstock-method',
    name:'twstockjiaoyi',
    component:resolve => require(['@/pages/twstock/twstockjiaoyi.vue'],resolve)
  },{
    path:'/mystock-intro',
    name:'mystock',
    component:resolve => require(['@/pages/mystock/mystock.vue'],resolve)
  },{
    path:'/mystock-fees',
    name:'mystockfuwu',
    component:resolve => require(['@/pages/mystock/mystockfuwu.vue'],resolve)
  },{
    path:'/mystock-method',
    name:'mystockjiaoyi',
    component:resolve => require(['@/pages/mystock/mystockjiaoyi.vue'],resolve)
  },{
    path:'/shstock-intro',
    name:'shstock',
    component:resolve => require(['@/pages/shstock/shstock.vue'],resolve)
  },{
    path:'/shstock-fees',
    name:'shstockfuwu',
    component:resolve => require(['@/pages/shstock/shstockfuwu.vue'],resolve)
  },{
    path:'/shstock-method',
    name:'shstockjiaoyi',
    component:resolve => require(['@/pages/shstock/shstockjiaoyi.vue'],resolve)
  },{
    path:'/service-fee&charge',
    name:'hkstock',
    component:resolve => require(['@/pages/hkstock/hkstock.vue'],resolve)
  },{
    path:'/apply-in-person',
    name:'assetmanage',
    component:resolve => require(['@/pages/assetmanage/assetmanage.vue'],resolve)
  },{
    path:'/apply-in-corporate',
    name:'caccount',
    component:resolve => require(['@/pages/assetmanage/caccount.vue'],resolve)
  },{
    path:'/person-send-by-post',
    name:'paccount',
    component:resolve => require(['@/pages/assetmanage/paccount.vue'],resolve)
  },{
    path:'/copporate-send-by-post',
    name:'caccounts',
    component:resolve => require(['@/pages/assetmanage/caccounts.vue'],resolve)
  },{
    path:'/accopen-app',
    name:'videopage',
    component:resolve => require(['@/pages/assetmanage/videopage.vue'],resolve)
  },{
    path:'/make-appointment',
    name:'makeappointment',
    component:resolve => require(['@/pages/assetmanage/makeappointment.vue'],resolve)
  }
  ,{
    path:'/FAQs',
    name:'comproblem',
    component:resolve => require(['@/pages/comproblem/comproblem.vue'],resolve)
  },{
    path:'/market-data',
    name:'sujufuwu',
    component:resolve => require(['@/pages/sujufuwu/sujufuwu.vue'],resolve)
  },{
    path:'/deposit&withdrawal',
    name:'zijincunqu',
    component:resolve => require(['@/pages/zijincunqu/zijincunqu.vue'],resolve)
  },{
    path:'/download-forms',
    name:'downtable',
    component:resolve => require(['@/pages/sujufuwu/downtable.vue'],resolve)
  },{
    path:'/trading-annoncement',
    name:'tonggao',
    meta:{title:'Announcements'}, 
    component:resolve => require(['@/pages/sujufuwu/tonggao.vue'],resolve)
  },{
    path:'/tongcom',
    name:'tongcom',
    component:resolve => require(['@/pages/sujufuwu/tongcom.vue'],resolve)
  },{
    path:'/market-holidays',
    name:'publicholidays',
    meta:{title:'Market Holiday'}, 
    component:resolve => require(['@/pages/sujufuwu/publicholidays.vue'],resolve)
  },
  {
    path:'/contactus',
    name:'contactus',
    meta:{title:'Contact Us'}, 
    component:resolve => require(['@/pages/contactus/contactus.vue'],resolve)
  },
  // bank and
  {
    path:'/investmentBanking',
    name:'investmentBanking',
    meta:{title:'Investment Banking'}, 
    component:resolve => require(['@/pages/investmentBanking/investmentBanking.vue'],resolve)
  },
  {
    path:'/assetManagement',
    name:'assetManagement',
    meta:{title:'Asset Management'},
    component:resolve => require(['@/pages/assetManagement/assetManagement.vue'],resolve)
  },
  {
    path:'/digitalBanking',
    name:'digitalBanking',
    meta:{title:'Digital Finance'},
    component:resolve => require(['@/pages/digitalBanking/digitalBanking.vue'],resolve)
  },
  {
    path:'/financlalLeasing',
    name:'financlalLeasing',
    meta:{title:'Financial Leasing'},
    component:resolve => require(['@/pages/financlalLeasing/financlalLeasing.vue'],resolve)
  },
  {
    path:'/bookFlights',
    name:'bookFlights',
    meta:{title:'Book Flights'},
    component:resolve => require(['@/pages/financlalLeasing/bookFlights.vue'],resolve)
  },
  {
    path:'/datePagePhone',
    name:'datePagePhone',
    component:resolve => require(['@/pages/financlalLeasing/datePage_phone.vue'],resolve)
  },
  {
    path:'/internationalTradeFinance',
    name:'internationalTradeFinance',
    component:resolve => require(['@/pages/internationalTradeFinance/internationalTradeFinance.vue'],resolve)
  },
  {
    path:'/wealthManagement',
    name:'wealthManagement',
    meta:{title:'Wealth Management'},
    component:resolve => require(['@/pages/wealthManagement/wealthManagement.vue'],resolve)
  },
  // bank end
  {
    path:'/aboutus',
    name:'aboutus',
    meta:{title:'About Us'},
    component:resolve =>require(['@/pages/aboutus/aboutus.vue'],resolve)
  },{
    path:'/zichanguanli',
    name:'zichanguanli',
    component:resolve =>require(['@/pages/zichanguanli/zichanguanli.vue'],resolve)
  },{
    path:'/touzi',
    name:'touzi',
    component:resolve => require(['@/pages/zichanguanli/touzi.vue'],resolve)
  },{
    path:'/caiwu',
    name:'caiwu',
    component:resolve => require(['@/pages/caiwu/caiwu.vue'],resolve)
  }
  ,{
    path:'/weituo',
    name:'weituo',
    component:resolve => require(['@/pages/weituo/weituo.vue'],resolve)
  }
];

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes,
  // 部署更改
  // base: '/investmentbanknew',//测试 /investmentbanknew  正式 /qmisibcom 
  base: '/qmisibcom',//正式临时
  // config 文件夹下 index.js 文件 assets文件 axiosconfig.js文件
  mode: 'history',
  // scrollBehavior(to,from,savedPosition){
  //   console.log(savedPosition)
  //   if(savedPosition){
  //     return savedPosition
  //   }else{
  //     return {
  //       x:0,
  //       y:0
  //     }
  //   }
  // }
})

// routers = new Router({
router.beforeEach((to, from, next) => {
  if(to.name !=='publicholidays' && window.sessionStorage['p_days']){
    window.sessionStorage['p_days'] = ''
  }
  $store.commit('upisland',true)
  setTimeout(()=>{
    $store.commit('upisland',false)
  },500)

  if(to.meta.title){
    document.title = to.meta.title + ' | QMIS INVESTMENT BANK LIMITED'
  }else{
    document.title = 'QMIS INVESTMENT BANK LIMITED'
  }
  // if(!window.localStorage.token&&from.path !=='/'){
  //   location.href = '/'
  //   next()
  // }else{
  next()
  // }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js